import { memo } from 'react';
import { Card, CardContent } from '../../../../../components/ui/card';
import { StatisticsDataPoint } from '../types';

interface ChartCardProps {
  data: StatisticsDataPoint[];
  title: string;
  yAxisLabel: string;
  color: string;
  ChartComponent: React.ComponentType<{
    data: StatisticsDataPoint[];
    title: string;
    yAxisLabel: string;
    color: string;
  }>;
}

export const ChartCard = memo(
  function ChartCard({ data, title, yAxisLabel, color, ChartComponent }: ChartCardProps) {
    if (data.length === 0) {
      return null;
    }

    return (
      <Card className="flex-1 min-w-[400px] bg-white border-[hsl(214,32%,91%)] shadow-sm">
        <CardContent className="p-6">
          <ChartComponent
            data={data}
            title={title}
            yAxisLabel={yAxisLabel}
            color={color}
          />
        </CardContent>
      </Card>
    );
  },
  (prevProps, nextProps) =>
    prevProps.data === nextProps.data &&
    prevProps.title === nextProps.title &&
    prevProps.yAxisLabel === nextProps.yAxisLabel &&
    prevProps.color === nextProps.color
);
